import _ from "lodash";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import withRouter from "helpers/withRouter";
import { fetchListCompany } from "../../redux/features/manager/managerSlice";
import { fetchTaxListCompany } from "../../redux/features/tax/taxSlice";
import TopMenu from "./TopMenu";
import { fetchUser } from "../../redux/features/user/userSlice";
import { createCustomDispatch } from "helpers/customDispatch";
import { switchWorkspaceContext } from "../../utils/workspaceSwitch";

class RenderTopMenus extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedCompany: "",
      managerCompanyChange: false,
      taxAgentCompanyChange: false,
    };
  }

  componentDidMount() {
    this.props
      .fetchUser()
      .then(() => {
        const { user } = this.props;
        if (user.is_manager) {
          this.props
            .fetchListCompany({ limit: 0 })
            .then((res) => {
              this.setState({
                selectedCompany: res.selected_company_id,
              });
            })
            .catch(_.noop);
        }

        if (
          user &&
          user.company &&
          (user.is_tax_agent || (user.is_manager && user.company.is_tax_agent))
        ) {
          this.props
            .fetchTaxListCompany()
            .then((res) => {
              this.setState({
                taxSelectedCompany: res.selected_company_id,
              });
            })
            .catch(_.noop);
        }
      })
      .catch(_.noop);
  }

  componentDidUpdate(prevProps) {
    const companyId = this.props.user?.company?.id;
    const prevCompanyId = prevProps.user?.company?.id;

    if (!companyId || companyId === prevCompanyId) {
      return;
    }

    const { user } = this.props;
    this.setState((prevState) => {
      const nextState = {};

      if (user.company && !user.company.is_tax_agent && prevState.selectedCompany !== companyId) {
        nextState.selectedCompany = companyId;
      }

      if (
        user.company &&
        (user.is_tax_agent || (user.is_manager && user.company.is_tax_agent)) &&
        prevState.taxSelectedCompany !== companyId
      ) {
        nextState.taxSelectedCompany = companyId;
      }

      return Object.keys(nextState).length ? nextState : null;
    });
  }

  changeCompanyName = async (selected, type) => {
    this.setState({
      [type]: true,
    });

    try {
      const result = await switchWorkspaceContext(
        this.props.reduxDispatch,
        {
          company_id: selected,
          preserveCurrentRoute: false,
        },
        { navigate: this.props.navigate },
      );

      if (result.status === "error") {
        this.setState({ changingError: result.error });
      }
    } catch (result) {
      this.setState({ changingError: result });
    } finally {
      this.setState({
        [type]: false,
      });
    }
  };

  render() {
    const {
      selectedCompany,
      taxSelectedCompany,
      managerCompanyChange,
      taxAgentCompanyChange,
    } = this.state;
    const { user, listCompany, taxListCompany, isLogged, loadingSetCompany } =
      this.props;

    return (
      isLogged && (
        <div>
          {(user && user.company && !user.company.is_tax_agent)  && (
            <TopMenu
              title={this.props.t("menu.selectCompany")}
              options={listCompany.companies}
              selected={selectedCompany}
              handleSelectChange={(value) =>
                this.setState({
                  selectedCompany: value,
                })
              }
              manager={user.is_manager}
              changeCompanyName={(selected) =>
                this.changeCompanyName(selected, "managerCompanyChange")
              }
              loadingButtonClick={loadingSetCompany && managerCompanyChange}
            />
          )}
          {(user && user.company && user.company.is_tax_agent)  && (
              <TopMenu
                title={this.props.t("menu.selectClient")}
                options={taxListCompany.companies}
                selected={taxSelectedCompany}
                manager={user.is_manager || true}
                handleSelectChange={(value) =>
                  this.setState({
                    taxSelectedCompany: value,
                  })
                }
                changeCompanyName={(selected) =>
                  this.changeCompanyName(selected, "taxAgentCompanyChange")
                }
                loadingButtonClick={loadingSetCompany && taxAgentCompanyChange}
              />
            )}
        </div>
      )
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user.user,
  listCompany: state.manager.listCompany,
  loadingSetCompany: state.manager.loadingSetCompany,
  taxListCompany: state.tax.taxListCompany,
  isLogged: state.auth.isLogged,
});

const mapDispatchToProps = (defaultDispatch) => {
  const dispatch = createCustomDispatch(defaultDispatch);

  return {
    reduxDispatch: defaultDispatch,
    fetchUser: () => dispatch(fetchUser()),
    fetchListCompany: (params) => dispatch(fetchListCompany(params)),
    fetchTaxListCompany: () => dispatch(fetchTaxListCompany()),
  };
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(RenderTopMenus))
);
